import { defHttp } from '@/utils/request';
import { WxCallbackParams } from './model/wxModel';

export const wxLogin = (backUrl) => {
  return defHttp.get<ResponseData<{ url: string }>>(
    {
      url: '/system/api/wxLogin',
      params: { backUrl: backUrl },
    },
    {
      withToken: false,
    },
  );
};

export const wxCallback = (query: WxCallbackParams) =>
  defHttp.get<ResponseData<{ token: string }>>(
    {
      url: '/system/api/callBack',
      params: query,
    },
    {
      withToken: false,
    },
  );

export const getOpenIdByCode = (code: string) =>
  defHttp.get<ResponseData<{ token: string; openid: string }>>(
    {
      url: '/system/api/getOpenId',
      params: {
        code: code,
      },
    },
    {
      withToken: false,
    },
  );

export const getTokenByOpenId = (openid: string) =>
  defHttp.get<ResponseData<{ token: string; needPower: Boolean }>>(
    {
      url: '/system/api/getToken',
      params: {
        openid: openid,
      },
    },
    {
      withToken: false,
    },
  );

interface WXJSAPI {
  signature: string;
  jsapi_ticket: string;
  noncestr: string;
  timestamp: number;
}
// 获取wx config
export const getWxConfig = () =>
  defHttp.get<ResponseData<WXJSAPI>>(
    {
      url: '/wxpay/getSign',
      params: {
        url: 'https://zc.innpst.com/',
      },
    },
    {
      withToken: false,
      // errorMessageMode: 'none',
    },
  );
